module.exports = __webpack_public_path__ + "img/769.35274aa8.jpg";